<a class="btn" title="Filter Devices" [class.btn-warning]="filterApplied" [class.btn-primary]="!filterApplied" (click)="showFilters()">
    <span data-toggle="tooltip" class="fa fa-filter fa-lg"></span>
</a>

<div bsModal #deviceFilter="bs-modal" class="modal fade" tabindex="-1" role="dialog" aria-labelledby="myModalLabel" aria-hidden="true" [config]="{ keyboard: false, backdrop: 'static' }">
    <div class="modal-dialog" style="width:1000px;">
        <div class="modal-content">
            <form (ngSubmit)="applyFilter()">
                <div class="modal-header">
                    <button type="button" class="close" data-dismiss="modal" aria-hidden="true" (click)="applyFilter()">&times;</button>
                    <h4 class="modal-title" id="myModalLabel">Filter Devices</h4>
                </div>
                <div class="modal-body">
                    <div class="row">
                        <div class="col-md-12">
                            <div class="input-group">
                                <div class="input-group-addon">
                                    <label>User Name</label>
                                </div>
                                <input name="UserFilterName" type="text" class="form-control" placeholder="User Name" [(ngModel)]="name" />
                            </div>
                        </div>
                    </div>
                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-success" *ngIf="filterApplied" (click)="clearFilter()">Clear Filter</button>
                    <button type="submit" class="btn btn-default">Apply Filter</button>
                </div>
            </form>
        </div>
    </div>
</div>